import { CircularProgress } from '@mui/material';
import { Navigate, Route, Routes } from 'react-router-dom';

import { ROUTE_MAP, USER_ROLE } from '../constants';
import { useAuthContext } from '../hooks';
import {
  BookingsReport,
  CallCenter,
  Dashboard,
  ForgotPassword,
  Login,
  Register,
  ResetPassword,
} from '../pages';
import { RootProvider } from '../providers';

const ROUTES_BY_USER_ROLE_MAP = {
  [USER_ROLE.USER]: (
    <>
      <Route path={ROUTE_MAP.DASHBOARD} element={<Dashboard />} />
      <Route path={ROUTE_MAP.CALL_CENTER} element={<CallCenter />} />
      <Route path={ROUTE_MAP.BOOKINGS_REPORT} element={<BookingsReport />} />
    </>
  ),
  [USER_ROLE.MANAGER]: (
    <>
      <Route path={ROUTE_MAP.DASHBOARD} element={<Dashboard />} />
      <Route path={ROUTE_MAP.BOOKINGS_REPORT} element={<BookingsReport />} />
    </>
  ),
};

export const Router = () => {
  const { isUserRoleLoading, hasUserRole, userRole } = useAuthContext();

  if (isUserRoleLoading) {
    return (
      <div className="h-screen flex justify-center items-center">
        <CircularProgress size={120} sx={{ color: '#FFFFFF' }} />
      </div>
    );
  }

  return (
    <Routes>
      {hasUserRole ? (
        <Route element={<RootProvider />}>
          {ROUTES_BY_USER_ROLE_MAP[userRole]}
        </Route>
      ) : (
        <>
          <Route path={ROUTE_MAP.LOGIN} element={<Login />} />
          <Route path={ROUTE_MAP.REGISTER} element={<Register />} />
          <Route
            path={ROUTE_MAP.FORGOT_PASSWORD}
            element={<ForgotPassword />}
          />
          <Route path={ROUTE_MAP.RESET_PASSWORD} element={<ResetPassword />} />
        </>
      )}
      <Route
        path="/"
        element={
          <Navigate
            to={hasUserRole ? ROUTE_MAP.DASHBOARD : ROUTE_MAP.LOGIN}
            replace
          />
        }
      />
      <Route
        path="*"
        element={
          <Navigate
            to={hasUserRole ? ROUTE_MAP.DASHBOARD : ROUTE_MAP.LOGIN}
            replace
          />
        }
      />
    </Routes>
  );
};
